import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@types+node@20.19.43_db0@0.3.4_eslint@9.39.5_jiti@1.21.7__ioredis@5.11.1_magic_wdymvkjqav3scy37r4rd7at6wm/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@types+node@20.19.43_db0@0.3.4_eslint@9.39.5_jiti@1.21.7__ioredis@5.11.1_magic_wdymvkjqav3scy37r4rd7at6wm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}